/* tslint:disable */

declare var Object: any;
export interface SFAttUploadSF6Interface {
  "id"?: number;
}

export class SFAttUploadSF6 implements SFAttUploadSF6Interface {
  "id": number;
  constructor(data?: SFAttUploadSF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAttUploadSF6`.
   */
  public static getModelName() {
    return "SFAttUploadSF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAttUploadSF6 for dynamic purposes.
  **/
  public static factory(data: SFAttUploadSF6Interface): SFAttUploadSF6{
    return new SFAttUploadSF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAttUploadSF6',
      plural: 'SFAttUploadSF6s',
      path: 'SFAttUploadSF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAttUploadSF6.ts